import OrchestratorAPI from './common.js';
import {
  type CanonicalFieldType,
  type CreateValues,
  type FindAllQueryParams,
} from '../models/orchestrator/canonicalFieldType.js';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/canonical-field-types';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(queryParams?: FindAllQueryParams): Promise<CanonicalFieldType[]> {
    const url = this.constructPath('/', queryParams);
    const { canonicalFieldTypes } = await this.common.getJSON(url);
    return canonicalFieldTypes.map(this.deserialize);
  }

  async create(values: CreateValues): Promise<CanonicalFieldType> {
    const url = this.constructPath('/');
    const { canonicalFieldType } = await this.common.postJSON(url, values);
    return this.deserialize(canonicalFieldType);
  }
  async findOneById(id: string): Promise<CanonicalFieldType> {
    const url = this.constructPath(`/${id}`);
    const { canonicalFieldType } = await this.common.getJSON(url);
    return this.deserialize(canonicalFieldType);
  }
}
